import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import toast from 'react-hot-toast';

import { loginSchema, type LoginInput } from '@realvisor/schemas';
import { useAuth } from '@/contexts/AuthContext';
import { Button, Input } from '@realvisor/ui';

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginInput>({
    resolver: zodResolver(loginSchema),
  });

  const onSubmit = async (data: LoginInput) => {
    setIsLoading(true);

    try {
      await signIn(data.email, data.password);
      navigate('/');
    } catch (error) {
      toast.error('Neplatné přihlašovací údaje');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Přihlášení</h2>
        <p className="mt-2 text-sm text-gray-600">
          Nemáte účet?{' '}
          <Link to="/register" className="font-medium text-primary-600 hover:text-primary-500">
            Zaregistrujte se
          </Link>
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-6">
        <Input
          label="E-mail"
          type="email"
          autoComplete="email"
          error={errors.email?.message}
          {...register('email')}
        />

        <Input
          label="Heslo"
          type="password"
          autoComplete="current-password"
          error={errors.password?.message}
          {...register('password')}
        />

        <div className="flex items-center justify-between">
          <label className="flex items-center gap-2">
            <input type="checkbox" className="h-4 w-4 rounded border-gray-300 text-primary-600" />
            <span className="text-sm text-gray-600">Zapamatovat si mě</span>
          </label>
          <Link to="/forgot-password" className="text-sm font-medium text-primary-600 hover:text-primary-500">
            Zapomenuté heslo?
          </Link>
        </div>

        <Button type="submit" className="w-full" isLoading={isLoading}>
          Přihlásit se
        </Button>
      </form>
    </>
  );
}
